import React from 'react';
import { SegmentedControl, Box } from '@mantine/core';
import { useLanguage } from '../contexts/LanguageContext';
export function LanguageSwitcher() {
  const {
    language,
    setLanguage
  } = useLanguage();
  return <Box data-id="element-51">
      <SegmentedControl value={language} onChange={value => setLanguage(value as 'en' | 'ar')} data={[{
      label: 'EN',
      value: 'en'
    }, {
      label: 'ع',
      value: 'ar'
    }]} size="xs" radius="xl" styles={{
      root: {
        backgroundColor: 'rgba(255,255,255,0.15)',
        padding: 2
      },
      indicator: {
        backgroundColor: '#ffffff'
      },
      label: {
        color: 'white',
        fontWeight: 600,
        fontSize: 11,
        padding: '4px 10px',
        '&[data-active]': {
          color: '#1a2332'
        }
      }
    }} data-id="element-52" />
    </Box>;
}